import AdvancedStandingReducer from './AdvancedStandingReducer';
export default AdvancedStandingReducer;
